import { EnvironmentProvider, LanguageProvider, TranslationsContextWrapper } from '@telia-common-components/shared';
import React from 'react';
import { TvPackageOfferingCarouselContent } from './TvPackageOfferingCarouselContent';
import TvPackageStore from '../../stores/TvPackageStore';
import { TvPackageStoreContext } from '../../stores/TvpackageStoreProvider';
let tvPackageStore;
export const TvPackageOfferingCarousel = (props) => {
    const { tier, app, language, isTestEnvironment, disableTranslationsStatistics, translations } = props;
    if (props.tvPackageStore) {
        tvPackageStore = props.tvPackageStore;
    }
    else if (tvPackageStore === undefined) {
        tvPackageStore = new TvPackageStore(tier, app, language);
    }
    return (React.createElement(EnvironmentProvider, { app: app, tier: tier },
        React.createElement(LanguageProvider, { lang: language },
            React.createElement(TranslationsContextWrapper, { translations: translations, disableStatistics: disableTranslationsStatistics, isTestEnvironment: isTestEnvironment },
                React.createElement(TvPackageStoreContext.Provider, { value: { tvPackageStore } },
                    React.createElement(TvPackageOfferingCarouselContent, { ...props }))))));
};
